import { graphql, readInlineData } from "react-relay";

import { article as articleData } from "~/data";
import type { helpersCheckIsLiveArticle$key } from "~/queries/__generated__/helpersCheckIsLiveArticle.graphql";

import type { ItemType } from "./atoms";

const liveItemPrefix = "live-content-item";
const timelineItemPrefix = "timeline-item";

export const getContainerId = (type: ItemType): string => {
  switch (type) {
    case "content":
      return "content-container";
    case "timeline":
      return "timeline-container";
  }

  return "";
};

export const getItemContainerId = (type: ItemType, entityId: string): string => {
  switch (type) {
    case "content":
      return `${liveItemPrefix}-${entityId ?? ""}`;
    case "timeline":
      return `${timelineItemPrefix}-${entityId ?? ""}`;
  }
  return "";
};

export const checkIfElementIsLiveItem = (elementId: string): boolean =>
  elementId.startsWith(liveItemPrefix);

export const checkIsLiveArticle = (reference: helpersCheckIsLiveArticle$key) => {
  const article = readInlineData(
    graphql`
      fragment helpersCheckIsLiveArticle on Article @inline {
        flattenTypeIds
        tmpLiveArticle {
          status
        }
      }
    `,
    reference,
  );

  const isLiveArticle = article.flattenTypeIds?.includes(articleData.types.live.entityUuid);
  const isLive = article.tmpLiveArticle?.status;

  return { isLive, isLiveArticle };
};
